import axios from '@/utils/api'
import empty from './empty'

const state = empty.state.emptyProcesso()

const getters = {
}

const actions = {
  async getInformacoes ({ commit }, { dados }) {
    const filtro = {
      simplificado: dados.simples,
      campoSimples: dados.campoSimples,
      numeroProcesso: dados.numeroProcesso,
      ordem: dados.ordem,
      ordemDirecao: dados.ordemDirecao,
      status: dados.status,
      pagina: dados.pagina,
      setorOrigem: dados.setorOrigem === '' ? null : dados.setorOrigem,
      tipoProcesso: dados.tipo === '' ? null : dados.tipo,
      dataInicial: dados.periodoSolicitacao ? dados.periodoSolicitacao[0] : null,
      dataFinal: dados.periodoSolicitacao ? dados.periodoSolicitacao[1] : null,
      municipio: dados.municipio ? dados.municipio : null
    }
    const data = await axios({
      method: 'POST',
      url: 'solicitarInformacao/filter',
      data: filtro
    })
    return data
  },

  async getInformacoesJuridico ({ commit }, { dados }) {
    const filtro = {
      simplificado: dados.simples,
      campoSimples: dados.campoSimples,
      numeroProcesso: dados.numeroProcesso,
      ordem: dados.ordem,
      ordemDirecao: dados.ordemDirecao,
      status: dados.status,
      pagina: dados.pagina,
      setorOrigem: dados.setorOrigem === '' ? null : dados.setorOrigem,
      tipoProcesso: dados.tipo === '' ? null : dados.tipo,
      dataInicial: dados.periodoSolicitacao ? dados.periodoSolicitacao[0] : null,
      dataFinal: dados.periodoSolicitacao ? dados.periodoSolicitacao[1] : null
    }
    const data = await axios({
      method: 'POST',
      url: 'solicitarInformacao/solicitacaoAcesso/filter',
      data: filtro
    })
    return data
  },

  async getDadosInformacaoSolicitada ({ commit }, idSolicitacao) {
    const data = await axios({
      method: 'GET',
      url: `solicitarInformacao/${idSolicitacao}`
    })
    return data
  },

  async getInformacoesSolicitacoesAcesso ({ commit }, { dados }) {
    const filtro = {
      simplificado: dados.simples,
      campoSimples: dados.campoSimples,
      numeroProcesso: dados.numeroProcesso,
      ordem: dados.ordem,
      ordemDirecao: dados.ordemDirecao,
      status: dados.status,
      pagina: dados.pagina,
      setorOrigem: dados.setorOrigem === '' ? null : dados.setorOrigem,
      tipoProcesso: dados.tipo === '' ? null : dados.tipo,
      dataInicial: dados.periodoSolicitacao ? dados.periodoSolicitacao[0] : null,
      dataFinal: dados.periodoSolicitacao ? dados.periodoSolicitacao[1] : null
    }
    const data = await axios({
      method: 'POST',
      url: 'solicitarInformacao/filterSolicitacaoAcesso',
      data: filtro
    })
    return data
  },

  async getSetoresInformacoesPendentes ({ commit }, numeroProcesso) {
    const data = await axios({
      method: 'GET',
      url: `solicitarInformacao/setoresInformacoesPendentes/${numeroProcesso}`
    })
    return data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/informacao.js